module.exports = __webpack_public_path__ + "static/media/mozza-2022-dt_fr.f6a66303.jpg";